import { executeDelete, executeGet, executeGetNoResultError, executePost, executePut } from '../common/apiCaller'
import {
  GetLotteryReservationsInputDto,
  GetLotteryReservationsDto,
  GetLotteryReservationHistroiesInputDto,
  GetLotteryReservationDto,
  PostLotteryReservationInputDto,
  PutLotteryReservationInputDto,
  DeleteLotteryReservationInputDto
} from '../dto/lotteryReservationsDto'

const apiName = 'citizen'
const apiPath = '/lottery-reservations'

export const executeGetLotteryReservations = async (input?: GetLotteryReservationsInputDto) => {
  return executeGet<GetLotteryReservationsDto[]>(apiName, apiPath, input)
}

export const executeGetLotteryReservationHistroies = async (input?: GetLotteryReservationHistroiesInputDto) => {
  return executeGet<GetLotteryReservationsDto[]>(apiName, `${apiPath}/history/list`, input)
}

export const executeGetLotteryReservation = (id: string) => {
  return executeGetNoResultError<GetLotteryReservationDto>(apiName, `${apiPath}/${id}`)
}

export const executeDeleteLotteryReservation = (id: string, input: DeleteLotteryReservationInputDto) => {
  return executeDelete<null>(apiName, `${apiPath}/${id}`, input)
}

export const executePostLotteryReservation = (input: PostLotteryReservationInputDto) => {
  return executePost<null>(apiName, apiPath, input)
}

export const executePutLotteryReservation = (id: string, input: PutLotteryReservationInputDto) => {
  return executePut<null>(apiName, `${apiPath}/${id}`, input)
}
